// extracted by mini-css-extract-plugin
export default {"textTag":"text-tag_textTag__9hhhT","largeTextTag":"text-tag_largeTextTag__ZHnp0","text":"text-tag_text__xg6CS","largeText":"text-tag_largeText__Lzvkd"};